export const PERIODS_TARGETS = {
  ADDED_PERIODS: 'addedPeriods',
  ADD_PERIOD: 'addPeriod',
  CREATE_PERIOD: 'createPeriod',
  PERIODS: 'periods'
};

export const PERIODS_DEFAULT_STATE = {
  [PERIODS_TARGETS.ADDED_PERIODS]: [],
  [PERIODS_TARGETS.ADD_PERIOD]: null,
  [PERIODS_TARGETS.CREATE_PERIOD]: null,
  [PERIODS_TARGETS.PERIODS]: []
};
